export default __webpack_public_path__ + "static/media/mxBanner.c241e076.png";